/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { LaboUserEdit } from 'components/LaboAdmin/LaboUserEdit';
import { PageContainer } from 'components/PageContainer/PageContainer';
import { useUserInfo } from 'hook/UseUserInfo';
import { isLaboAdmin } from 'utils/constants/roles';
import { GENERATE_ROUTE, ROUTES } from 'utils/constants/routes';
import { ErrorName } from 'utils/constants/error.name';


export const LaboUserEditPage = () => {
  const { laboratory, personContactDetailsId } = useParams();
  const history = useHistory();
  const {role} = useUserInfo();

  useEffect(() => {
    if (!isLaboAdmin(role)) {
      history.push(GENERATE_ROUTE(ROUTES.ERROR), { errorMessage: ErrorName.UNAUTHORIZED_ACTION });
    }
  },[role])

  return (
    <PageContainer>
      <LaboUserEdit laboratoryId={laboratory} personContactDetailsId={personContactDetailsId}/>
    </PageContainer>
  )
}